import { useEffect, useState } from 'react';
import { Wifi, WifiOff, Cloud, CloudOff } from 'lucide-react';
import { offlineService } from '../../services/offline.service';

export function ConnectionStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [queueSize, setQueueSize] = useState(0);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    // Subscribe to connection status changes
    const unsubscribe = offlineService.onStatusChange((online) => {
      setIsOnline(online);
      setShowStatus(true);
      
      // Hide status after 3 seconds
      setTimeout(() => setShowStatus(false), 3000);
    });

    // Update queue size periodically
    const intervalId = setInterval(() => {
      setQueueSize(offlineService.getQueue().length);
    }, 1000);

    return () => {
      unsubscribe();
      clearInterval(intervalId);
    };
  }, []);

  if (!showStatus && isOnline) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 animate-slide-down">
      <div
        className={`px-4 py-2 rounded-full shadow-lg flex items-center gap-2 ${
          isOnline
            ? 'bg-[#00B277] text-white'
            : 'bg-[#E02020] text-white'
        }`}
      >
        {isOnline ? (
          <>
            <Wifi className="w-4 h-4" />
            <span className="text-[12px] font-medium">Back online</span>
            {queueSize > 0 && (
              <span className="text-[10px] bg-white/20 px-2 py-0.5 rounded-full">
                Syncing {queueSize} {queueSize === 1 ? 'item' : 'items'}
              </span>
            )}
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span className="text-[12px] font-medium">No connection</span>
          </>
        )}
      </div>
    </div>
  );
}
